import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useProjectDetail } from './hooks/useProjectDetail';
import { ProjectDetailHeader } from './components/ProjectDetailHeader';
import { ProjectDetailTabs } from './components/ProjectDetailTabs';
import { ProjectOverviewKpis } from './components/ProjectOverviewKpis';
import { ProjectOverviewMain } from './components/ProjectOverviewMain';
import { ProjectOverviewActivity } from './components/ProjectOverviewActivity';
import { ProjectOverviewSidebar } from './components/ProjectOverviewSidebar';
import { ProjectTasksMain } from './components/ProjectTasksMain';
import { ProjectProgressMain } from './components/ProjectProgressMain';
import { ProjectDocsMain } from './components/ProjectDocsMain';
import { ProjectPersonnelMain } from './components/ProjectPersonnelMain';
import { ProjectEquipmentMain } from './components/ProjectEquipmentMain';
import { ProjectMaterialsMain } from './components/ProjectMaterialsMain';
import { ProjectCostsMain } from './components/ProjectCostsMain';
import { ProjectLogsMain } from './components/ProjectLogsMain';
import { ProjectHistoryMain } from './components/ProjectHistoryMain';

export function ProjectDetailPage() {
  const { id } = useParams();
  const { project, isLoading } = useProjectDetail(id || '');
  const [activeTab, setActiveTab] = useState('overview');

  if (isLoading) {
    return (
      <div className="p-6 space-y-6 animate-pulse bg-slate-50/50 min-h-screen">
        <div className="h-48 rounded-md bg-white border border-slate-100" />
        <div className="h-14 rounded-md bg-white border border-slate-100" />
        <div className="grid grid-cols-6 gap-4">
           {Array.from({ length: 6 }).map((_, i) => (
             <div key={i} className="h-24 rounded-md bg-white border border-slate-100" />
           ))}
        </div>
      </div>
    );
  }

  if (!project) {
    return (
      <div className="py-20 text-center text-slate-400">
        <i className="ri-error-warning-line text-4xl mb-2" />
        <p className="text-xs lg:text-sm font-normal">Không tìm thấy thông tin dự án</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-slate-50/50 pb-10">
      {/* Top Navigation / Breadcrumbs could go here if not in Topbar */}
      
      <div className="p-6 space-y-6">
        {/* Header Block */}
        <ProjectDetailHeader project={project} />

        {/* Navigation Tabs */}
        <div className="rounded-md overflow-hidden  border border-slate-100">
          <ProjectDetailTabs activeTab={activeTab} onTabChange={setActiveTab} />
          
          {/* Dynamic Content based on Tabs */}
          {activeTab === 'overview' && (
            <div className="p-4 lg:p-6 space-y-6 bg-white/50">
              {/* KPI Row */}
              <ProjectOverviewKpis />

              {/* Main Dashboard Grid */}
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
                {/* Left: Main Details (Description, Milestones, Docs) */}
                <div className="lg:col-span-5 xl:col-span-5">
                   <ProjectOverviewMain />
                </div>

                {/* Middle: Activity Log */}
                <div className="lg:col-span-4 xl:col-span-4">
                   <ProjectOverviewActivity onViewAll={() => setActiveTab('logs')} />
                </div>

                {/* Right: Sidebar (Progress, Participants, Notes) */}
                <div className="lg:col-span-3 xl:col-span-3">
                   <ProjectOverviewSidebar project={project} />
                </div>
              </div>
            </div>
          )}

          {activeTab === 'tasks' && (
            <div className="p-4 lg:p-6 bg-white/50">
              <ProjectTasksMain />
            </div>
          )}

          {activeTab === 'progress' && (
            <div className="p-4 lg:p-6 bg-white/50">
              <ProjectProgressMain />
            </div>
          )}

          {activeTab === 'docs' && (
            <div className="p-4 lg:p-6 bg-white/50">
              <ProjectDocsMain />
            </div>
          )}

          {activeTab === 'personnel' && (
            <div className="p-4 lg:p-6 bg-white/50">
              <ProjectPersonnelMain />
            </div>
          )}

          {activeTab === 'equipment' && (
            <div className="p-4 lg:p-6 bg-white/50">
              <ProjectEquipmentMain />
            </div>
          )}

          {activeTab === 'materials' && (
            <div className="p-4 lg:p-6 bg-white/50">
              <ProjectMaterialsMain />
            </div>
          )}

          {activeTab === 'costs' && (
            <div className="p-4 lg:p-6 bg-white/50">
              <ProjectCostsMain />
            </div>
          )}

          {activeTab === 'logs' && (
            <div className="p-4 lg:p-6 bg-white/50">
              <ProjectLogsMain />
            </div>
          )}

          {activeTab === 'history' && (
            <div className="p-4 lg:p-6 bg-white/50">
              <ProjectHistoryMain />
            </div>
          )}

          {activeTab !== 'overview' && activeTab !== 'tasks' && activeTab !== 'progress' && activeTab !== 'docs' && activeTab !== 'personnel' && activeTab !== 'equipment' && activeTab !== 'materials' && activeTab !== 'costs' && activeTab !== 'logs' && activeTab !== 'history' && (
            <div className="p-20 text-center text-slate-400 bg-white">
               <i className="ri-tools-line text-4xl mb-2 block" />
               <p className="text-xs lg:text-sm font-normal">Chế độ xem "{activeTab}" đang được phát triển...</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProjectDetailPage;
